import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {EMAIL_REG} from "../../shared/constants";
import {MessageService} from "../../core/service/message.service";

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  mail: string;
  constructor(public dialogRef: MatDialogRef<any>,
              public messageService: MessageService,
              @Inject(MAT_DIALOG_DATA) public data: {mail: string}) {
    this.mail = this.data.mail;
  }

  ngOnInit(): void {
  }

  invalidEmail(): boolean {
    return !EMAIL_REG.test(this.mail);
  }

  submit() {
    if (this.invalidEmail()) {
      this.messageService.pushError('不正なメールアドレスです')
      return;
    }
    this.dialogRef.close({
      mail: this.mail
    })
  }

}
